var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-b-6",attrs:{"id":'jump-' + _vm.index}},[_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-primary btn-theme btn-large",attrs:{"href":"#sales-page"}},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }